'use client';

import { makeAutoObservable } from 'mobx';
import { UiStore } from '@/stores/ui';

export class AiHistorySidebarStore {
  public sidebarOpen = true;

  constructor(public readonly uiStore: UiStore) {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }
}
